<template>
  <Modal :modal="profilePictureModalRef" :steps="[{ component: ProfilePictureModalContent, id: 'profile-picture' }]" />
</template>

<script lang="ts" setup>
import ProfilePictureModalContent from './profile-picture-modal-content/profile-picture-modal-content.vue'

import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetProfilePictureModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const profilePictureModalRef = selectGetProfilePictureModal(modalsStore)
</script>
